import { PARTICIPANT_NAME_MAX_LENGTH } from 'app/services/rtc/constants';

// Maximum length for name, and gender fields.
// This value corresponds to the max length validation in user.rb on the backend.
export const MAX_FIELD_LENGTH = 100;

// Maximum length for the display name field.
// Since display names are sent up to the realtime server during calls, they are limited to a length that
// realtime server allows in order to prevent an unreasonable amount of data from being sent up.
export const DISPLAY_NAME_MAX_LENGTH = PARTICIPANT_NAME_MAX_LENGTH;
